var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.getId},domProps:{"textContent":_vm._s(_vm.getLabel)}}),_vm._v(" "),_c('ckeditor',{attrs:{"id":_vm.getId,"name":_vm.getId},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }